import React, { useState } from "react";
import { Modal, Input, Button } from "semantic-ui-react";
import styles from "./ModalCreateCollection.module.scss";
import { ABI_TO_CREATE, BYTECODE_TO_CREATE } from "@/constants/web3";
import { ethers } from "ethers";
import { MdLibraryMusic } from "react-icons/md";
import { MdImage } from "react-icons/md";
import useWeb3 from "@/hooks/useWeb3";
import { executeInPolygon } from "@/store/web3.utils";
import MarketplaceNotification from "../ui/MarketplaceNotification.modal";

const CollectionForm = () => {
  const [collectionAddress, setCollectionAddress] = useState("");
  const [collectionName, setCollectionName] = useState("");
  const [collectionSymbol, setCollectionSymbol] = useState("");
  const [collectionType, setCollectionType] = useState("art");
  const [defaultRoyalty, setDefaultRoyalty] = useState(0);
  const [loading, setLoading] = useState(false);

  const { createUserCollection, createNotification } = useWeb3();

  const deployCollection = async () => {
    try {
      setLoading(true);

      const provider = new ethers.providers.Web3Provider(
        window.ethereum,
        "any"
      );
      // Prompt user for account connections
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();

      const myContract = new ethers.ContractFactory(
        ABI_TO_CREATE,
        BYTECODE_TO_CREATE,
        signer
      );

      const contract = await myContract.deploy(
        collectionName,
        collectionSymbol,
        defaultRoyalty
      );

      await createUserCollection(
        contract.address,
        collectionName,
        collectionType
      );

      setCollectionAddress(contract.address);
    } catch (error) {
      createNotification("Error", "Error creating the collection.");
    } finally {
      setLoading(false);
    }
  };

  const itemSelected = {
    border: "1px solid #fff",
  };

  if (collectionAddress) {
    return (
      <>
        <div>
          <h3>Collection created</h3>
          <a>
            <p>Address: {collectionAddress}</p>
          </a>
          <p>
            Please wait for a few minutes and then sync the collection on the
            previous page.
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <h3>Create Collection</h3>
      <br></br>
      <div className={styles.row} style={{ justifyContent: "space-around" }}>
        <div
          className={styles.item}
          style={collectionType === "art" ? itemSelected : {}}
          onClick={() => {
            setCollectionType("art");
          }}
        >
          <MdImage size={60} color="white" />
          <p>Art</p>
        </div>
        <div
          className={styles.item}
          style={collectionType === "music" ? itemSelected : {}}
          onClick={() => {
            setCollectionType("music");
          }}
        >
          <MdLibraryMusic color="white" size={"60"} />
          <p>Music</p>
        </div>
      </div>
      <div className={styles.row}>
        <Input
          className={styles.input}
          onChange={(e) => setCollectionName(e.target.value)}
          placeholder="Name "
        />
      </div>
      <div className={styles.row}>
        <div className={styles.fullWidth}>
          <Input
            className={styles.input}
            onChange={(e) => setCollectionSymbol(e.target.value)}
            placeholder="Symbol"
          />
        </div>
        <div className={styles.fullWidth}>
          <Input
            className={styles.input}
            onChange={(e) => setDefaultRoyalty(e.target.value)}
            placeholder="Royalty Fee "
            type="number"
          />
        </div>
      </div>
      <div className={styles.row} style={{ justifyContent: "center" }}>
        <Button
          onClick={() => executeInPolygon(deployCollection)}
          loading={loading}
          className={styles.button}
        >
          Confirm
        </Button>
      </div>
    </>
  );
};

const ModalCreateCollection = ({ open, setOpen }) => {
  return (
    <>
      <Modal
        className={styles.modal}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Modal.Content className={styles.modalContent}>
          <CollectionForm />
        </Modal.Content>
      </Modal>
      <MarketplaceNotification />
    </>
  );
};

export default ModalCreateCollection;
